import { useReducer } from 'react';

const initialState = {
  isOpen: false,
  supportingText: ''
};

const ACTION_TYPES = {
  OPEN_ADD_DX_DIALOG: 'OPEN_ADD_DX_DIALOG',
  CLOSE_ADD_DX_DIALOG: 'CLOSE_ADD_DX_DIALOG'
};

const ACTIONS = {
  openAddDxDialog: (supportingText = '') => ({
    type: ACTION_TYPES.OPEN_ADD_DX_DIALOG,
    payload: {
      supportingText
    }
  }),
  closeAddDxDialog: () => ({
    type: ACTION_TYPES.CLOSE_ADD_DX_DIALOG
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_ADD_DX_DIALOG: {
      const { payload: { supportingText } } = action;

      return {
        ...state,
        isOpen: true,
        supportingText
      };
    }

    case ACTION_TYPES.CLOSE_ADD_DX_DIALOG: {
      return {
        ...state,
        isOpen: false,
        supportingText: ''
      };
    }

    default: {
      throw Error('addDxDialog reducer default case should never hit')
    }
  }
};

const useAddDxDialog = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = supportingText => {
    const text = typeof supportingText === 'string' ? supportingText : '';
    dispatch(ACTIONS.openAddDxDialog(text));
  };

  const close = () => dispatch(ACTIONS.closeAddDxDialog());

  const boundActions = {
    open,
    close
  };

  return [state, boundActions];
};

export default useAddDxDialog;
